import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import userOrderServices from './user_order_services';

export const GetMyOrder = createAsyncThunk(
  'user_order/get_user_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.getMyOrder(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetMySelectionOrder = createAsyncThunk(
  'user_order/get_user_selection_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.getMyOrder(payload);

      return { ...response, my_selection_order: payload?.my_selection_order };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetUserSingleOrder = createAsyncThunk(
  'user_order/get_single_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.getSingleOrder(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditUserOrder = createAsyncThunk(
  'user_order/edit_user_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.editOrder(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditUserSingleOrder = createAsyncThunk(
  'user_order/edit_user_single_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.editOrder(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditAddressSingleOrder = createAsyncThunk(
  'user_order/edit_address_single_order',
  async (payload, thunkAPI) => {
    try {
      let response = await userOrderServices.editAddressOrder(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetStatusAdvncaedCount = createAsyncThunk(
  'user_order/get_status_advanced_count',
  async (_, thunkAPI) => {
    try {
      let response = await userOrderServices.getAllStatusAdvancedCount();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllUserOrderCount = createAsyncThunk(
  'user_order/get_all_user_order_count',
  async (_, thunkAPI) => {
    try {
      let response = await userOrderServices.getAllUserOrderCount();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
